export default "__VITE_ASSET__NRL0ZgAv__"